/* eslint-disable @typescript-eslint/naming-convention */
export type ElementType = 'text' | 'textarea' | 'number' | 'yesno' | 'multiple' | 'dropdown';

export type Branch = 'yes' | 'no' | `string`;

export enum SCREENING_TYPE {
  NONE = 'none',
  KNOKOUT = 'knockout',
  REVIEW = 'review',
}

export enum QUESTIONNAIRE_ELEMENT_TYPE {
  FREE_FORM = 'free-form',
  YESNO = 'specific',
  YESNO_WITH_IMAGE = 'specific-with-image',
  MULTI_CHOICE = 'multiple-choice',
  MULTI_CHOICE_WITH_IMAGE = 'multiple-choice-with-image',
  VIDEO_RESPONSE = 'video-upload',
  DOCUMENT_UPLOAD = 'document-upload',
}
export enum LANGUAGE_CODE {
  EN = 'en',
  FR = 'fr',
}

export enum TEMPLATE_MODE {
  CREATE = 'create',
  EDIT = 'edit',
  COPY = 'copy',
}
